"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function CodeStamp() {
  const { currentLang } = useLanguage();
  const isEs = currentLang === "es";
  return (
    <section className="bg-white border-4 border-[#064e3b] py-10 px-12 max-w-2xl mx-auto my-12 rounded-lg text-center">
      <p className="uppercase tracking-[0.3em] text-xs text-gray-500 font-bold">
        MIAMI-DADE COUNTY
      </p>
      <p className="uppercase tracking-[0.2em] text-xs text-gray-400 mt-1">
        {isEs ? "APROBACIÓN DE CONTROL DE PRODUCTO" : "PRODUCT CONTROL APPROVAL"}
      </p>
      <h2 className="text-3xl md:text-4xl font-bold text-[#064e3b] mt-4 leading-tight">
        HVHZ STANDARD
      </h2>
      <p className="text-lg text-gray-600 mt-2">
        {isEs ? "Zona de Huracanes de Alta Velocidad" : "High-Velocity Hurricane Zone"}
      </p>
      <div className="mt-6 pt-6 border-t border-[#064e3b]/20">
        <p className="font-mono text-xs text-gray-500">
          NOA Required: TAS 201, 202, 203
        </p>
        <p className="font-mono text-xs text-gray-400 mt-1">
          Miami-Dade Code §1626 · ASCE 7-22 · ASTM E1996
        </p>
      </div>
    </section>
  );
}